<template>
  <v-app style="height: 100%; max-width: 600px; margin: auto;"
    :class="{on_desktop: $vuetify.breakpoint.smAndUp}"
  >
    <v-main class="grey lighten-3">
      <slot>
        <router-view />
      </slot>
    </v-main>
  </v-app>
</template>
<script>


export default {
  name: 'EmptyLayout',
}
</script>

<style>
  body {
    background-color: black;
  }
</style>